import { forwardRef, useCallback } from 'react';
import { Slot } from 'radix-ui';
import { cn } from '@/lib/utils';
import { haptics } from '@/lib/haptics';
import { buttonVariants } from '@/components/ui/button-variants';
const Button = forwardRef(({
  className,
  variant = 'default',
  size = 'default',
  asChild = false,
  onClick,
  children,
  ...props
}, ref) => {
  const Comp = asChild ? Slot.Root : 'button';
  const handleClick = useCallback(e => {
    haptics.selection();
    onClick?.(e);
  }, [onClick]);
  return <Comp ref={ref} data-slot="button" data-variant={variant} data-size={size} className={cn(buttonVariants({
    variant,
    size,
    className
  }))} onClick={handleClick} {...props}>
        <span className="relative z-10 flex items-center justify-center gap-2">{children}</span>
        {variant !== 'link' && <span className="absolute inset-0 bg-current opacity-0 group-hover/button:opacity-[0.08] active:opacity-[0.12] transition-opacity duration-150 pointer-events-none" />}
      </Comp>;
});
Button.displayName = 'Button';
export { Button };
